import { render, staticRenderFns } from "./createbillDraft.vue?vue&type=template&id=b70cad86&scoped=true&"
import script from "./createbillDraft.vue?vue&type=script&lang=js&"
export * from "./createbillDraft.vue?vue&type=script&lang=js&"
import style0 from "./createbillDraft.vue?vue&type=style&index=0&id=b70cad86&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70cad86",
  null
  
)

export default component.exports